import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { Checking, Enrol, Login, useAuth } from "./auth";
import { Dashboard } from "./facilitator/Dashboard";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

// Two screens, one bundle, no router. Caddy already serves index.html for unknown
// paths, so reading the path once here is the whole of it — a router would be a
// dependency and a concept for the sake of one branch.
const isFacilitator = window.location.pathname.replace(/\/+$/, "") === "/facilitator";

/**
 * Sign-in wraps both screens, so neither has to think about it.
 *
 * The dashboard is a plain 403 for a learner rather than a hidden page: the server
 * refuses it, and hiding the tab as well would only mean a learner who typed the URL got
 * a blank screen instead of an answer. What *is* worth doing is not offering it — see
 * `Dashboard`, which tells a learner plainly that this is not their screen.
 */
function Root() {
  const { state, signedIn, enrolled, signOut } = useAuth();

  if (state.status === "checking") return <Checking />;
  // The device gate comes first, and only ever once per device. Offering the sign-in form
  // to an unenrolled device would mean every submission is refused for a reason that has
  // nothing to do with what they typed.
  if (state.status === "enrol") return <Enrol onEnrolled={enrolled} />;
  if (state.status === "out") return <Login onSignedIn={signedIn} />;

  return isFacilitator ? (
    <Dashboard me={state.me} onSignOut={() => void signOut()} />
  ) : (
    <App me={state.me} onSignOut={() => void signOut()} />
  );
}

createRoot(root).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
